import { render, staticRenderFns } from "./SuperAdminMerchantToken.vue?vue&type=template&id=1ff2a132&scoped=true&lang=pug"
import script from "./SuperAdminMerchantToken.vue?vue&type=script&lang=ts"
export * from "./SuperAdminMerchantToken.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminMerchantToken.vue?vue&type=style&index=0&id=1ff2a132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2a132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabItem,VTabs,VTabsItems})
